/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./circle-loader.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./circle-loader.component";
var styles_CircleLoaderComponent = [i0.styles];
var RenderType_CircleLoaderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CircleLoaderComponent, data: {} });
export { RenderType_CircleLoaderComponent as RenderType_CircleLoaderComponent };
export function View_CircleLoaderComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["class", "loader"]], null, null, null, null, null))], null, null); }
export function View_CircleLoaderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-circle-loader", [], null, null, null, View_CircleLoaderComponent_0, RenderType_CircleLoaderComponent)), i1.ɵdid(1, 114688, null, 0, i2.CircleLoaderComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CircleLoaderComponentNgFactory = i1.ɵccf("app-circle-loader", i2.CircleLoaderComponent, View_CircleLoaderComponent_Host_0, {}, {}, []);
export { CircleLoaderComponentNgFactory as CircleLoaderComponentNgFactory };
